import { useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { Box, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { FC } from 'react';

interface BackToProps {
    title: string;
}

const BackTo: FC<BackToProps> = ({ title }) => {
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <MainCard sx={{ mb: 2 }} onClick={handleBackClick}>
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    cursor: 'pointer',
                    '&:hover .hover-text': {
                        textDecoration: 'underline',
                    },
                }}
            >
                <ChevronLeftIcon />
                <Typography variant="h5" ml={1} className="hover-text">
                    {title}
                </Typography>
            </Box>
        </MainCard>
    );
};

export default BackTo;
